const antdTheme = {
  token: {
    colorPrimary: '#004632',
    colorLink: '#004632',
    colorLinkHover: '#006B4A',
    fontFamily: "'Inter', 'Segoe UI', 'Roboto', sans-serif",
    borderRadius: 8,
    fontSize: 14,
  },
};

export default antdTheme;
